<template>
  <div>

    <Row class="search-con">
      <Col>
        <Button @click="backHistory" class="search-btn">返回</Button>
      </Col>
    </Row>
    <Card>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="letterDetailFlag"
      title="私信详情"
      footer-hide
      >
      <p v-for="line in details" :key="line.id" style = 'font-size:15px; margin-top:10px'>{{ line }}</p>
    </Modal>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";

import { listLetter, letterDetail} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      letterDetailFlag: false,
      tableLoading: true,
      allMoney: 0.0,
      classify_id:'',
      startTime: "",
      endTime: "",
      details:[],
      dy_id:'',
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "客户名称" , key: "customer_username", editable: true },
        {
          title: "Handle",
          key: "handle",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                 type:"primary",
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showLetterDetail(params);
                    },
                  },
                },
                "查看详情"
              )
            ]);
          },
        }
      ],
      tableData: [],
    };
  },
  methods: {
    backHistory() {
      this.$router.go(-1);
    },
    showLetterDetail(params) {
      this.details = []
      var params = {
        dy_id: params.row.dy_user_id,
        dy_customer_id: params.row.dy_customer_id
      }
      letterDetail(params).then((res) => {
        var detailList = res.data.data
        for (var i = 0; i < detailList.length; i++) {
          var type_ = detailList[i]['type']
          if (type_ == 1){
            this.details[i] = "自己:" + detailList[i]['content']
          }else{
            this.details[i] = detailList[i]['customer_username'] + ":" + detailList[i]['content']
          }
        }
        this.letterDetailFlag = true;
      });
    },
    changeUserStatus(value, params){
      let data = new FormData();
      data.append("black", value);
      userBlack(data, params.row.id).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success("成功!");
        } else {
          this.$Message.error(res.data.msg);
        }
      });

    }, editSumit(formValidate) {
      let data = new FormData();
      data.set("id", formValidate.id);
      data.set("tag_id", formValidate.tag_id);
      editUserTag(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },deleteFlowerModal(params){
      this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              deleteFlower(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.handleSearch()
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        dy_id: this.dy_id
      };
      listLetter(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.dy_id = this.$route.query.id;
    this.classify_id = this.$route.query.classify_id;
    this.handleSearch();
  },
};
</script>
